var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-results" },
    [
      _vm.loadingApplicants
        ? _c("Loading")
        : _c(
            "div",
            { staticClass: "job-results--items" },
            [
              _vm.applicants.length === 0
                ? _c(
                    "NoMatches",
                    {
                      attrs: {
                        title:
                          "Wir sind auf der Suche nach deinem persönlichen Best-Match."
                      }
                    },
                    [
                      _c("div", [
                        _c("b", [
                          _vm._v(
                            "Wenn du aktuell keine Matches siehst, mach dir keine Sorgen, das ist ganz normal."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-1" }, [
                        _vm._v(
                          "\n\t\t\t\tskilldoo müllt dich nicht mit unpassenden Bewerbungen zu, sondern zeigt dir ausschließlich deine\n\t\t\t\tTop-Matches. Wir informieren dich per E-Mail, sobald es einen passenden Match gibt.\n\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-3" }, [
                        _vm._v(
                          "\n\t\t\t\tSolltest Du längere Zeit keine passenden Bewerber finden, überlege, ob du die Anforderungen\n\t\t\t\tverringern möchtest.\n\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "no-matches--content-button-container" },
                        [
                          _c("Button", {
                            attrs: {
                              text: "Anforderungen ändern",
                              icon: "checkmark",
                              href:
                                "/kundenbereich/jobs/" +
                                _vm.jobProfileListItem.jobProfile.id +
                                "/bearbeiten"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              [
                _c("Pagination", {
                  staticClass: "mb-4",
                  attrs: {
                    page: _vm.page,
                    total: _vm.meta.total,
                    "items-per-page": _vm.itemsPerPage
                  },
                  on: { input: _vm.loadApplicants },
                  model: {
                    value: _vm.page,
                    callback: function($$v) {
                      _vm.page = $$v
                    },
                    expression: "page"
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.applicants, function(applicant) {
                  return _c("ListItem", {
                    key: applicant.id,
                    attrs: {
                      "job-profile-list-item": _vm.jobProfileListItem,
                      "job-id": applicant.jobId,
                      applicant: applicant,
                      permissions: _vm.permissions
                    },
                    on: { remove: _vm.loadApplicants }
                  })
                }),
                _vm._v(" "),
                _c("Pagination", {
                  staticClass: "mb-4",
                  attrs: {
                    page: _vm.page,
                    total: _vm.meta.total,
                    "items-per-page": _vm.itemsPerPage
                  },
                  on: { input: _vm.loadApplicants },
                  model: {
                    value: _vm.page,
                    callback: function($$v) {
                      _vm.page = $$v
                    },
                    expression: "page"
                  }
                })
              ]
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }